export function ensureBootstrapIcons() {
  if (typeof document === 'undefined') return;

  const id = 'osirus-bootstrap-icons';
  if (document.getElementById(id)) return;

  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = 'https://agent.osirus.ai/lib/umd/bootstrap-icons.css';
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
}
